import { useTranslation } from '@frontend/i18n';
import { Button } from '../../../button';
import { TrackingIds } from './date-navigator';
import { styles } from './date-navigator.styles';

type DateNavigatorWrapperProps = {
  children: React.ReactNode;
  showNavigationButtons: boolean;
  navigationButtonHoverLabel?: { next: string; prev: string };
  trackingIds?: TrackingIds;
  handleNavigation: (num: number) => void;
};

export const DateNavigatorWrapper = ({
  children,
  showNavigationButtons,
  navigationButtonHoverLabel,
  trackingIds,
  handleNavigation,
}: DateNavigatorWrapperProps) => {
  const { t } = useTranslation();

  return (
    <div css={styles.navigatorContainer}>
      {showNavigationButtons && (
        <Button
          variant='secondary'
          size='small'
          iconName='caret-left'
          css={styles.navigationButton}
          trackingId={trackingIds?.prevButton}
          hoverLabel={navigationButtonHoverLabel?.prev || t('Previous Day')}
          onClick={() => handleNavigation(-1)}
        />
      )}
      <div css={{ position: 'relative' }}>{children}</div>
      {showNavigationButtons && (
        <Button
          variant='secondary'
          size='small'
          iconName='caret-right'
          css={styles.navigationButton}
          trackingId={trackingIds?.nextButton}
          hoverLabel={navigationButtonHoverLabel?.next || t('Next Day')}
          onClick={() => handleNavigation(1)}
        />
      )}
    </div>
  );
};
